import React from 'react';
import PropTypes from 'prop-types';

export const PageTabsContext = React.createContext();
export const PageTabBarExtraContext = React.createContext(() => {});

export const PageTabsProvider = ({ activeTab, setTabBarExtra, children }) => (
  <PageTabsContext.Provider value={activeTab}>
    <PageTabBarExtraContext.Provider value={setTabBarExtra}>
      {children}
    </PageTabBarExtraContext.Provider>
  </PageTabsContext.Provider>
);

PageTabsProvider.propTypes = {
  activeTab: PropTypes.string,
  setTabBarExtra: PropTypes.func,
  children: PropTypes.node.isRequired,
};

PageTabsProvider.defaultProps = {
  activeTab: null,
  setTabBarExtra: () => {},
};
